import request from './http.js'

// 用户信息
export function userinfo(data){
    return request({
        url:'/index/user/get_user_info',
        data
    })
}
// 修改用户信息
export function editUserinfo(data){
    return request({
        url: '/index/user/set_user_info',
        data
    })
}
// 获取验证码
export function sendCodemsg(data){
    return request({
        url: '/index/user/send_msg_code',
        data
    })
}
// 修改手机号
export function changeMobile(data){
    return request({
        url: '/index/user/change_mobile',
        data
    })
}
// 修改密码
export function changePwd(data){
    return request({
        url: '/index/user/change_pwd',
        data
    })
}


// 产品列表
export function productList(data){
    return request({
        url: '/index/product/product_list',
        data
    })
}


// 创建系统 

export function createSystem(data){
    return request({
        url:'/index/product/create_shop',
        method:'POST',
        data,
        timeout:0
    })


}


// 初始化店铺


export function initShop(data){
    return request({
        url:'/index/product/init_shop',
        method:'POST',
        data,
        timeout:0
    })
}


export function delShop(data){
    return request({
        url:'/index/product/del_shop',
        method:'POST',
        data,
        timeout:0
    })
}